// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"0e3454dd","662":"4e48231a"}[chunkId] + ".chunk.css";
};